import {
    RECOMMENDED_CLANS_SUCCESS,
    RECOMMENDED_CLANS_APPEND_SUCCESS,
    RECOMMENDED_CLANS_ERROR,
    RECOMMENDED_CLANS_REQUEST,
    RECOMMENDED_CLANS_NEXT_PAGE,
    RECOMMENDED_CLANS_PREV_PAGE,
    RECOMMENDED_CLANS_NEXT_PAGE_SEARCH,
    RECOMMENDED_CLANS_PREV_PAGE_SEARCH,
    RECOMMENDED_CLANS_SET_LANGUAGE_CODE,
    RECOMMENDED_CLANS_SET_MEMBERS_COUNT,
    RECOMMENDED_CLANS_SET_LIST_TYPE,
    RECOMMENDED_CLANS_SET_SEARCH_TERM,
    RECOMMENDED_CLANS_ACCOUNT_STATUS_CLEAR,
    RECOMMENDED_CLANS_ACCOUNT_STATUS_FETCHING_COMPLETED,
    RECOMMENDED_CLANS_ACCOUNT_STATUS_ERROR,
    RECOMMENDED_CLANS_ACCOUNT_STATUS_REQUEST,
    RECOMMENDED_CLANS_ACCEPT_INVITE_REQUEST,
    RECOMMENDED_CLANS_ACCEPT_INVITE_SUCCESS,
    RECOMMENDED_CLANS_ACCEPT_INVITE_ERROR,
    RECOMMENDED_CLANS_AUTO_JOIN_REQUEST,
    RECOMMENDED_CLANS_AUTO_JOIN_SUCCESS,
    RECOMMENDED_CLANS_AUTO_JOIN_ERROR,
    RECOMMENDED_CLANS_SEND_APPLICATION_REQUEST,
    RECOMMENDED_CLANS_SEND_APPLICATION_SUCCESS,
    RECOMMENDED_CLANS_SEND_APPLICATION_ERROR,
    RECOMMENDED_CLANS_FILTER_SETTINGS_REQUEST,
    RECOMMENDED_CLANS_FILTER_SETTINGS_SUCCESS,
    RECOMMENDED_CLANS_FILTER_SETTINGS_ERROR,
    RECOMMENDED_CLANS_CALL_ENTER_CLAN,
    RECOMMENDED_CLANS_SYSTEM_ERROR,
    RECOMMENDED_CLANS_STOP_LOADING,
} from 'state/actions/recommended_clans'
import {
    DEFAULT_LIST_TYPE,
    DEFAULT_MEMBERS_COUNT,
    DEFAULT_LANGUAGES,
} from 'containers/Landing/components/LandingClans/components/Filters/constants'
import { RESET_CLAN } from '../actions/clan'

export const ITEMS_PER_PAGE = 3
export const LIMIT = 99

const initialState = {
    accountStatus: {
        attempt: 0,
        hasError: false,
        isAccountInClan: false,
        isFetchingCompleted: false,
        loading: false,
    },
    hasError: false,
    items: [],
    joinResult: {
        cooldownTill: null,
        currentClan: null,
        hasNoErrors: false,
        errors: {},
        applied: [],
        joinedClan: null,
        loading: false,
    },
    attemptsEnterClan: {
        acceptInvite: false,
        autoJoin: false,
        sendApplication: false,
    },
    languages: DEFAULT_LANGUAGES,
    listType: DEFAULT_LIST_TYPE,
    loadedBefore: false,
    loading: false,
    loadingSettings: false,
    membersCount: DEFAULT_MEMBERS_COUNT,
    paging: {
        current: 0,
        total: 0,
        offset: 0,
    },
    pagingSearch: {
        current: 0,
        total: 0,
        offset: 0,
    },
    searchTerm: null,
    dwhType: '',
    total: 0,
}

// eslint-disable-next-line complexity
export default (state = initialState, action = {}) => {
    switch (action.type) {
    case RECOMMENDED_CLANS_REQUEST: {
        return {
            ...state,
            hasError: false,
            loading: true,
        }
    }
    case RECOMMENDED_CLANS_SUCCESS: {
        return {
            ...state,
            hasError: false,
            items: action.payload.items,
            dwhType: action.payload.dwhType,
            total: action.payload.total,
            joinResult: {
                ...state.joinResult,
                cooldownTill: action.payload.cooldownTill,
            },
            loadedBefore: true,
            loading: false,
            loadingSettings: false,
            paging: action.payload.isSearch ? state.paging : {
                ...state.paging,
                current: 0,
                total: Math.ceil(action.payload.total / ITEMS_PER_PAGE),
                offset: 0,
            },
            pagingSearch: action.payload.isSearch ? {
                ...state.pagingSearch,
                total: Math.ceil(action.payload.total / ITEMS_PER_PAGE),
                offset: 0,
            } : state.pagingSearch,
        }
    }
    case RECOMMENDED_CLANS_APPEND_SUCCESS: {
        return {
            ...state,
            hasError: false,
            items: [...state.items, ...action.payload.items],
            dwhType: action.payload.dwhType,
            total: action.payload.total,
            joinResult: {
                ...state.joinResult,
                cooldownTill: action.payload.cooldownTill,
            },
            loadedBefore: true,
            loading: false,
            paging: action.payload.isSearch ? state.paging : {
                ...state.paging,
                total: Math.ceil(action.payload.total / ITEMS_PER_PAGE),
                offset: state.paging.offset + LIMIT,
            },
            pagingSearch: action.payload.isSearch ? {
                ...state.pagingSearch,
                total: Math.ceil(action.payload.total / ITEMS_PER_PAGE),
                offset: state.pagingSearch.offset + LIMIT,
            } : state.pagingSearch,
        }
    }
    case RECOMMENDED_CLANS_ERROR: {
        return {
            ...state,
            hasError: true,
            items: [],
            loadedBefore: true,
            loading: false,
            loadingSettings: false,
        }
    }
    case RECOMMENDED_CLANS_NEXT_PAGE: {
        return {
            ...state,
            paging: {
                ...state.paging,
                current: state.paging.current + 1,
            },
        }
    }
    case RECOMMENDED_CLANS_PREV_PAGE: {
        return {
            ...state,
            paging: {
                ...state.paging,
                current: state.paging.current > 0 ? state.paging.current - 1 : 0,
            },
        }
    }
    case RECOMMENDED_CLANS_NEXT_PAGE_SEARCH: {
        return {
            ...state,
            pagingSearch: {
                ...state.pagingSearch,
                current: state.pagingSearch.current + 1,
            },
        }
    }
    case RECOMMENDED_CLANS_PREV_PAGE_SEARCH: {
        return {
            ...state,
            pagingSearch: {
                ...state.pagingSearch,
                current: state.pagingSearch.current > 0 ? state.pagingSearch.current - 1 : 0,
            },
        }
    }
    case RECOMMENDED_CLANS_SYSTEM_ERROR: {
        return {
            ...state,
            joinResult: {
                ...state.joinResult,
                loading: true,
                errors: {
                    ...state.joinResult.errors,
                    [action.payload.clanId]: action.payload.errorCode,
                },
            },
        }
    }
    case RECOMMENDED_CLANS_STOP_LOADING: {
        return {
            ...state,
            joinResult: {
                ...state.joinResult,
                loading: false,
            },
        }
    }
    case RESET_CLAN: {
        return initialState
    }
    default:
        return fetchClansFilterReducer(state, action)
    }
}

const fetchClansFilterReducer = (state = initialState, action = {}) => {
    switch (action.type) {
    case RECOMMENDED_CLANS_FILTER_SETTINGS_REQUEST: {
        return {
            ...state,
            hasError: false,
            loading: true,
            loadingSettings: true,
        }
    }
    case RECOMMENDED_CLANS_FILTER_SETTINGS_SUCCESS: {
        return {
            ...state,
            languages: action.payload.languages,
            listType: action.payload.game_activity,
            loading: false,
        }
    }
    case RECOMMENDED_CLANS_FILTER_SETTINGS_ERROR: {
        return {
            ...state,
            hasError: false,
            loading: false,
        }
    }
    case RECOMMENDED_CLANS_SET_LANGUAGE_CODE: {
        return {
            ...state,
            languages: action.payload.languages,
            searchTerm: null,
        }
    }
    case RECOMMENDED_CLANS_SET_MEMBERS_COUNT: {
        return {
            ...state,
            membersCount: action.payload.membersCount,
            searchTerm: null,
        }
    }
    case RECOMMENDED_CLANS_SET_LIST_TYPE: {
        return {
            ...state,
            listType: action.payload.listType,
            searchTerm: null,
        }
    }
    case RECOMMENDED_CLANS_SET_SEARCH_TERM: {
        return {
            ...state,
            searchTerm: action.payload.searchTerm,
            pagingSearch: {
                current: 0,
                total: 0,
                offset: 0,
            },
        }
    }
    default:
        return acceptInviteReducer(state, action)
    }
}

const acceptInviteReducer = (state = initialState, action = {}) => {
    switch (action.type) {
    case RECOMMENDED_CLANS_ACCEPT_INVITE_REQUEST: {
        return {
            ...state,
            joinResult: {
                ...state.joinResult,
                hasNoErrors: false,
                loading: true,
                joinedClan: null,
            },
            attemptsEnterClan: {
                ...state.attemptsEnterClan,
                acceptInvite: true,
            },
        }
    }
    case RECOMMENDED_CLANS_ACCEPT_INVITE_SUCCESS: {
        return {
            ...state,
            joinResult: {
                ...state.joinResult,
                currentClan: null,
                hasNoErrors: true,
                errors: {
                    ...state.joinResult.errors,
                    [action.payload.clan.id]: 0,
                },
                joinedClan: action.payload.clan,
                loading: false,
            },
        }
    }
    case RECOMMENDED_CLANS_ACCEPT_INVITE_ERROR: {
        return {
            ...state,
            joinResult: {
                ...state.joinResult,
                currentClan: action.payload.currentClan,
                hasNoErrors: false,
                errors: {
                    ...state.joinResult.errors,
                    [action.payload.clanId]: action.payload.errorCode,
                },
                joinedClan: null,
                loading: false,
            },
        }
    }
    default:
        return autoJoinReducer(state, action)
    }
}

const autoJoinReducer = (state = initialState, action = {}) => {
    switch (action.type) {
    case RECOMMENDED_CLANS_AUTO_JOIN_REQUEST: {
        return {
            ...state,
            joinResult: {
                ...state.joinResult,
                hasNoErrors: false,
                loading: true,
                joinedClan: null,
            },
            attemptsEnterClan: {
                ...state.attemptsEnterClan,
                autoJoin: true,
            },
        }
    }
    case RECOMMENDED_CLANS_AUTO_JOIN_SUCCESS: {
        return {
            ...state,
            joinResult: {
                ...state.joinResult,
                currentClan: null,
                hasNoErrors: true,
                errors: {
                    ...state.joinResult.errors,
                    [action.payload.clan.id]: 0,
                },
                joinedClan: action.payload.clan,
                loading: false,
            },
        }
    }
    case RECOMMENDED_CLANS_AUTO_JOIN_ERROR: {
        return {
            ...state,
            joinResult: {
                ...state.joinResult,
                currentClan: action.payload.currentClan,
                hasNoErrors: false,
                errors: {
                    ...state.joinResult.errors,
                    [action.payload.clanId]: action.payload.errorCode,
                },
                joinedClan: null,
                loading: false,
            },
        }
    }
    default:
        return sendApplicationReducer(state, action)
    }
}

const sendApplicationReducer = (state = initialState, action = {}) => {
    switch (action.type) {
    case RECOMMENDED_CLANS_SEND_APPLICATION_REQUEST: {
        return {
            ...state,
            joinResult: {
                ...state.joinResult,
                hasNoErrors: false,
                loading: true,
                joinedClan: null,
            },
            attemptsEnterClan: {
                ...state.attemptsEnterClan,
                sendApplication: true,
            },
        }
    }
    case RECOMMENDED_CLANS_SEND_APPLICATION_SUCCESS: {
        return {
            ...state,
            joinResult: {
                ...state.joinResult,
                currentClan: null,
                hasNoErrors: true,
                errors: {
                    ...state.joinResult.errors,
                    [action.payload.clan.id]: 0,
                },
                applied: [...state.joinResult.applied, action.payload.clan.id],
                joinedClan: action.payload.clan,
                loading: false,
            },
        }
    }
    case RECOMMENDED_CLANS_SEND_APPLICATION_ERROR: {
        return {
            ...state,
            joinResult: {
                ...state.joinResult,
                currentClan: action.payload.currentClan,
                hasNoErrors: false,
                errors: {
                    ...state.joinResult.errors,
                    [action.payload.clanId]: action.payload.errorCode,
                },
                joinedClan: null,
                loading: false,
            },
        }
    }
    default:
        return accountStatusReducer(state, action)
    }
}

const accountStatusReducer = (state = initialState, action = {}) => {
    switch (action.type) {
    case RECOMMENDED_CLANS_ACCOUNT_STATUS_REQUEST: {
        return {
            ...state,
            accountStatus: {
                ...state.accountStatus,
                attempt: state.accountStatus.attempt + 1,
                isFetchingCompleted: false,
                hasError: false,
                loading: true,
            },
        }
    }
    case RECOMMENDED_CLANS_ACCOUNT_STATUS_CLEAR: {
        return {
            ...state,
            accountStatus: {
                attempt: 0,
                hasError: false,
                isAccountInClan: false,
                isFetchingCompleted: false,
                loading: false,
            },
            joinResult: {
                ...state.joinResult,
                hasNoErrors: false,
            },
        }
    }
    case RECOMMENDED_CLANS_ACCOUNT_STATUS_FETCHING_COMPLETED: {
        return {
            ...state,
            accountStatus: {
                ...state.accountStatus,
                isFetchingCompleted: true,
                hasError: action.payload.isAccountConflicted,
                isAccountInClan: action.payload.isAccountInClan,
                loading: false,
            },
        }
    }
    case RECOMMENDED_CLANS_ACCOUNT_STATUS_ERROR: {
        return {
            ...state,
            accountStatus: {
                ...state.accountStatus,
                hasError: true,
                loading: false,
            },
        }
    }
    case RECOMMENDED_CLANS_CALL_ENTER_CLAN: {
        return {
            ...state,
            attemptsEnterClan: {
                acceptInvite: false,
                autoJoin: false,
                sendApplication: false,
            },
        }
    }
    default:
        return action, state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/recommended_clans.js